/* ============================================================
   NOCTURNAL — LANDINGPAGE 3D CONTOUR SLEEP MASK · v2
   Seitenlogik. Alle Liquid-Werte kommen aus window.NOC,
   der Block steht am Ende von layout/mask-v2.liquid.

   Bewusst KEINE Eroeffnungssequenz: der Besucher kommt aus
   dem Feed und sieht sofort Produkt, Preis und Kauf-Button.

   TRACKING
   AddToCart wird hier nicht von Hand gefeuert — Shopifys
   Facebook-Kanal meldet das Ereignis selbst und dedupliziert
   es mit der Conversions-API. ViewContent feuert sonst
   niemand, deshalb steht es unten drin, mit echtem Wert.
   ============================================================ */
(function () {
  'use strict';

  var D = window.NOC;
  if (!D || !D.varianten) { return; }

  var $  = function (s) { return document.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(document.querySelectorAll(s)); };
  var leise = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var FARBNAMEN = {
    black: 'Schwarz', cream: 'Creme', burgundy: 'Bordeaux',
    gray: 'Grau', green: 'Grün', white: 'Weiß'
  };

  /* Drei Dimensionen, weil drei Artikel dranhaengen:
     maske  — waehlbar, gilt fuer alle drei Angebote
     brille — waehlbar, gilt nur fuers Duo
     plugs  — nicht waehlbar, das Bundle bekommt die schwarzen
              Stoepsel; die Zeile steht hier, damit der Schluessel
              vollstaendig ist und nicht stumm auf undefined faellt. */
  var maske  = 'black';
  var brille = 'black';
  var plugs  = 'black';
  var angebot = 'duo';

  function euro(cent) {
    return (cent / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  /* Zaehlt einen Betrag hoch. Das Ziel steht als Cent-Wert in
     data-ziel; waehrend des Laufs wird nur der Text ersetzt, die
     Breite bleibt durch tabular-nums stabil, damit nichts zappelt.
     Laeuft ueber requestAnimationFrame statt setInterval, damit
     der Browser die Bildrate bestimmt und nichts stottert. */
  function hochzaehlen(el) {
    if (!el) { return; }
    var ziel = parseInt(el.getAttribute('data-ziel'), 10);
    if (!ziel || ziel <= 0) { return; }
    /* Der richtige Betrag steht ZUERST da, erst danach wird
       animiert. Grund: requestAnimationFrame pausiert auf
       verborgenen Seiten. Setzte man wie ueblich mit 0 an und
       liesse rAF hochzaehlen, stuende auf einem im Hintergrund
       geoeffneten Tab dauerhaft "0,00 €" — ein falscher Preis,
       und zwar der denkbar schaedlichste. Lieber keine
       Animation als eine falsche Zahl. */
    el.textContent = euro(ziel);
    if (document.visibilityState !== 'visible') { return; }

    var dauer = 620, start = 0;
    function schritt(jetzt) {
      if (!start) { start = jetzt; }
      var p = Math.min(1, (jetzt - start) / dauer);
      /* Weich auslaufend, damit die letzte Ziffer nicht anspringt. */
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = euro(Math.round(ziel * e));
      if (p < 1) { requestAnimationFrame(schritt); }
    }
    el.textContent = euro(0);
    requestAnimationFrame(schritt);
  }

  /* --------------------------------------------------------
     Farbschluessel vereinheitlichen
     ------------------------------------------------------------
     Shopify liefert die Optionswerte in der Sprache, in der sie
     im Shop gepflegt sind — und das ist nicht ueberall dieselbe:
     die Einzelmaske kommt uebersetzt als "schwarz/creme/burgund"
     herein, Duo und Bundle unuebersetzt als "black/cream/...".
     Ein direkter Vergleich mit den Werten der Radiobuttons geht
     deshalb ins Leere; genau daran ist "Nur die Maske" bisher
     gescheitert. Statt auf eine Schreibweise zu wetten, wird
     jeder Wert auf einen festen Schluessel abgebildet. Kommt
     spaeter eine Uebersetzung dazu, reicht eine Zeile hier.
     -------------------------------------------------------- */
  var ALIAS = {
    black: 'black', schwarz: 'black',
    cream: 'cream', creme: 'cream',
    burgundy: 'burgundy', burgund: 'burgundy', bordeaux: 'burgundy',
    gray: 'gray', grey: 'gray', grau: 'gray',
    green: 'green', gruen: 'green', 'grün': 'green',
    white: 'white', weiss: 'white', 'weiß': 'white'
  };
  function norm(wert) {
    if (!wert) { return wert; }
    var k = String(wert).toLowerCase().trim();
    return ALIAS[k] || k;
  }
  /* Baut aus den Rohschluesseln aus Liquid eine Karte mit
     vereinheitlichten Schluesseln. Der Platzhalter "_" aus dem
     Liquid-Block faellt dabei raus. */
  function karte(roh) {
    var aus = {};
    Object.keys(roh || {}).forEach(function (k) {
      if (k === '_') { return; }
      aus[k.split('|').map(norm).join('|')] = roh[k];
    });
    return aus;
  }
  var VAR = {
    single: karte(D.varianten.single),
    duo:    karte(D.varianten.duo),
    bundle: karte(D.varianten.bundle)
  };

  /* --------------------------------------------------------
     Ausverkaufte Farben
     ------------------------------------------------------------
     Die Farbkreise standen fest im Markup, ohne Bezug zum Lager. Seit
     29.09.2026 gibt es die Brille nur in Schwarz — ohne diese Pruefung
     haette die Seite Grau und Gruen weiter angeboten und der Kauf waere
     erst an der Kasse gescheitert. Ist die gewaehlte Farbe aus, springt
     die Auswahl auf die erste lieferbare.
     -------------------------------------------------------- */
  var DA = { maske: karte((D.farbenDa || {}).maske || {}), brille: karte((D.farbenDa || {}).brille || {}) };
  function farbeDa(dim, farbe) {
    var m = DA[dim] || {};
    return m[farbe] !== false;
  }
  /* Lieferbar ist ein Angebot nur, wenn Shopify die Variante freigibt.
     Ist sie aus, sagt der Knopf das, statt den Klick ins Leere laufen
     zu lassen. */
  function angebotDa(tier) {
    var id = variante(tier);
    return !!id && (D.varDa || {})[String(id)] !== false;
  }
  function knoepfePflegen() {
    $$('[data-kauf]').forEach(function (b) {
      var da = angebotDa(b.dataset.kauf);
      b.disabled = !da;
      if (!b.dataset.text) { b.dataset.text = b.textContent; }
      b.textContent = da ? b.dataset.text : 'Ausverkauft';
    });
    var sc = document.getElementById('sticky-cta');
    if (sc) {
      var daS = angebotDa(angebot);
      sc.disabled = !daS;
      if (!sc.dataset.text) { sc.dataset.text = sc.textContent; }
      sc.textContent = daS ? sc.dataset.text : 'Ausverkauft';
    }
  }
  function swatchesPflegen() {
    ['maske', 'brille'].forEach(function (dim) {
      var eingaben = $$('input[data-dim="' + dim + '"]');
      eingaben.forEach(function (inp) {
        var da = farbeDa(dim, inp.value);
        inp.disabled = !da;
        var label = inp.closest('.swatch');
        if (label) {
          label.classList.toggle('swatch--aus', !da);
          label.title = (inp.dataset.label || '') + (da ? '' : ' – ausverkauft');
        }
      });
      var aktuell = dim === 'maske' ? maske : brille;
      if (farbeDa(dim, aktuell)) { return; }
      var ersatz = eingaben.filter(function (i) { return !i.disabled; })[0];
      if (!ersatz) { return; }
      ersatz.checked = true;
      if (dim === 'maske') {
        maske = ersatz.value;
        if (maskeName) { maskeName.textContent = ersatz.dataset.label; }
      } else {
        brille = ersatz.value;
        if (brilleName) { brilleName.textContent = ersatz.dataset.label; }
      }
    });
  }

  /* Sucht die Variante zum aktuellen Farbstand. Duo und Bundle
     haben zwei Optionen, die Einzelmaske nur eine — deshalb der
     zusammengesetzte Schluessel. Findet sich die Kombination
     nicht (etwa weil in Shopify eine Variante fehlt), faellt die
     Suche auf die schwarze Zweitfarbe zurueck und erst danach auf
     null, damit der Kaufbutton eine ehrliche Fehlermeldung zeigt
     statt still die falsche Farbe in den Korb zu legen. */
  function variante(tier) {
    var m = VAR[tier] || {};
    if (tier === 'single') { return m[maske] || null; }
    if (tier === 'duo')    { return m[maske + '|' + brille] || m[maske + '|black'] || null; }
    if (tier === 'bundle') { return m[maske + '|' + plugs]  || m[maske + '|black'] || null; }
    return null;
  }

  /* Beschriftung der Leiste und des Bild-Etiketts. Beim Duo
     interessieren beide Farben, sonst nur die Maske. */
  function farbText(tier) {
    if (tier === 'duo') { return 'Maske ' + FARBNAMEN[maske] + ' · Brille ' + FARBNAMEN[brille]; }
    return FARBNAMEN[maske];
  }

  /* --------------------------------------------------------
     1 — Ueberschriften Wort fuer Wort
     ------------------------------------------------------------
     Jede Ueberschrift wird in Woerter zerlegt, jedes Wort bekommt
     seinen Index als CSS-Variable. Die Bewegung selbst steht im
     Stylesheet — hier passiert nur das Zerlegen und das Ausloesen.

     Die H1 im Hero laeuft sofort los, ohne auf irgendetwas zu warten:
     Preis und Kauf-Button sind davon nicht betroffen und stehen von
     der ersten Sekunde an da. Nach dem <br> wechselt die Behandlung —
     die zweite Zeile taucht aus dem Schwarz auf.
     -------------------------------------------------------- */
  function zerlegen(el, dunkelAbBr) {
    if (el.dataset.split === '1') { return; }
    el.dataset.split = '1';
    var i = 0, j = 0, nachBr = false;

    function gehen(quelle, ziel) {
      Array.prototype.forEach.call(quelle.childNodes, function (n) {
        if (n.nodeType === 3) {
          n.textContent.split(/(\s+)/).forEach(function (t) {
            if (!t) { return; }
            if (/^\s+$/.test(t)) { ziel.appendChild(document.createTextNode(' ')); return; }
            var w = document.createElement('span');
            w.className = 'w';
            var inner = document.createElement('i');
            inner.textContent = t;
            if (dunkelAbBr && nachBr) {
              w.className = 'w w--dark';
              inner.style.setProperty('--j', j++);
            } else {
              inner.style.setProperty('--i', i++);
            }
            w.appendChild(inner);
            ziel.appendChild(w);
          });
        } else if (n.nodeName === 'BR') {
          nachBr = true;
          ziel.appendChild(document.createElement('br'));
        } else {
          var klon = n.cloneNode(false);
          gehen(n, klon);
          ziel.appendChild(klon);
        }
      });
    }

    var frag = document.createDocumentFragment();
    gehen(el, frag);
    el.textContent = '';
    el.appendChild(frag);
    el.setAttribute('data-split', '1');
  }

  var h1 = $('#hero h1');
  if (h1) { zerlegen(h1, true); }
  var h2s = $$('h2');
  h2s.forEach(function (h) { zerlegen(h, false); });

  if (leise) {
    if (h1) { h1.classList.add('on'); }
    h2s.forEach(function (h) { h.classList.add('on'); });
  } else {
    if (h1) {
      /* Der Browser muss den Ausgangszustand einmal berechnet haben,
         sonst fasst er Anfang und Ende zusammen und es passiert nichts. */
      void h1.offsetWidth;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { h1.classList.add('on'); });
      });
    }
    if ('IntersectionObserver' in window) {
      var ioH = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('on'); ioH.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
      h2s.forEach(function (h) { void h.offsetWidth; ioH.observe(h); });
    } else {
      h2s.forEach(function (h) { h.classList.add('on'); });
    }
  }

  /* --------------------------------------------------------
     2 — Erscheinen beim Scrollen
     -------------------------------------------------------- */
  /* Lebenszeichen an das Sicherheitsnetz im <head>. Ab hier ist
     sicher, dass dieses Skript das Einblenden uebernimmt — der
     Notfall-Timer dort schaltet sich daraufhin ab. */
  window.NOClebt = true;

  var rv = $$('.rv');
  if (leise || !('IntersectionObserver' in window)) {
    rv.forEach(function (el) { el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    rv.forEach(function (el) { io.observe(el); });
  }

  /* --------------------------------------------------------
     3 — Farbauswahl
     -------------------------------------------------------- */
  var heroImg = $('#hero-img'), heroTag = $('#hero-tag');
  var maskeName = $('#maske-name'), brilleName = $('#brille-name');
  var thSingle = $('.th-single'), thDuo = $('.th-duo'), thBundle = $('.th-bundle');

  /* Netz gegen tote Bilddateien.
     Die Farbbilder haengen an fest eingetragenen Dateinamen, und
     die brechen, sobald jemand die Datei in Shopify neu hochlaedt
     — Shopify vergibt dann einen neuen Namen mit angehaengter
     Ziffer. Genau das ist passiert: In der Angebotskachel "Nur die
     Maske" stand ein kaputter Rahmen. Auffangen laesst sich das
     nur beim Laden, weil Liquid ein fehlendes File nicht erkennt.
     Faellt ein Bild aus, kommt das Produktfoto aus Shopify. */
  [thSingle, thDuo, thBundle].forEach(function (bild) {
    if (!bild || !D.notbild) { return; }
    bild.addEventListener('error', function () {
      if (bild.dataset.notbild === '1') { return; }  /* nur einmal */
      bild.dataset.notbild = '1';
      bild.src = D.notbild;
    });
  });

  /* Tauscht ein Bild erst, wenn die neue Datei geladen ist —
     sonst blitzt kurz ein leerer Rahmen auf. */
  function bildTausch(el, quelle) {
    if (!el || !quelle || el.src === quelle) { return; }
    el.classList.add('swapping');
    var vorlader = new Image();
    vorlader.onload = function () { el.src = quelle; el.classList.remove('swapping'); };
    vorlader.onerror = function () { el.classList.remove('swapping'); };
    vorlader.src = quelle;
  }

  /* Alle Bilder auf den aktuellen Farbstand bringen. Der Hero
     zeigt immer das Duo, weil die Anzeige das Duo bewirbt; die
     drei Kacheln zeigen jeweils ihr eigenes Angebot. */
  function bilderAktualisieren() {
    var idDuo = variante('duo'), idBun = variante('bundle');

    bildTausch(heroImg, D.bilder[idDuo]);
    if (heroImg) {
      heroImg.alt = 'The Midnight Duo: 3D Contour Sleep Mask in ' + FARBNAMEN[maske] +
                    ' mit den Nocturnal Amber Glasses in ' + FARBNAMEN[brille];
    }
    if (heroTag) { heroTag.textContent = farbText('duo'); }

    if (thSingle && D.farbbilder[maske]) {
      thSingle.src = D.farbbilder[maske];
      thSingle.alt = '3D Contour Sleep Mask in ' + FARBNAMEN[maske];
    }
    if (thDuo && D.mini[idDuo]) {
      thDuo.src = D.mini[idDuo];
      thDuo.alt = 'The Midnight Duo — Maske in ' + FARBNAMEN[maske] + ', Brille in ' + FARBNAMEN[brille];
    }
    if (thBundle && D.mini[idBun]) {
      thBundle.src = D.mini[idBun];
      thBundle.alt = 'Deep Sleep Bundle — Maske in ' + FARBNAMEN[maske] + ' mit Sleep Tape und Sleep Plugs';
    }
  }

  $$('input[data-dim]').forEach(function (input) {
    input.addEventListener('change', function () {
      if (input.dataset.dim === 'maske') {
        maske = input.value;
        if (maskeName) { maskeName.textContent = input.dataset.label; }
      } else {
        brille = input.value;
        if (brilleName) { brilleName.textContent = input.dataset.label; }
      }
      bilderAktualisieren();
      leiste();
      knoepfePflegen();
    });
  });

  /* --------------------------------------------------------
     4 — Querschnitt
     -------------------------------------------------------- */
  var gFlat = $('#g-flat'), gCont = $('#g-contour'), press = $('#press'), luft = $('#airpuff');
  var r1 = $('#r1'), r2 = $('#r2'), r3 = $('#r3'), cap = $('#cut-cap');
  var bFlat = $('#cut-flat'), bCont = $('#cut-contour');
  var TEXT = {
    flach: 'Das Gewicht des Stoffs landet auf Wimpern und Augapfel. Bei Seitenschläfern kommt das Gewicht des Kopfes dazu — und an der Nase bleibt ein Spalt.',
    kontur: 'Die Maske stützt sich auf Stirn, Nasenrücken und Wange ab. Über dem Auge bleibt Luft — die Lider können sich frei bewegen.'
  };

  function cut(kontur) {
    if (!gFlat || !gCont) { return; }
    gFlat.style.opacity = kontur ? '0' : '1';
    gCont.style.opacity = kontur ? '1' : '0';
    if (press) { press.style.opacity = kontur ? '0' : '1'; }
    if (luft)  { luft.style.opacity  = kontur ? '1' : '0'; }
    r1.textContent = kontur ? 'Keiner' : 'Dauerhaft';
    r2.textContent = kontur ? 'Vollständig' : 'Nicht möglich';
    r3.textContent = kontur ? 'Ausgespart' : 'Sichtbar';
    var f = kontur ? '#C9A876' : '#D9705E';
    r1.style.color = r2.style.color = r3.style.color = f;
    cap.textContent = kontur ? TEXT.kontur : TEXT.flach;
    bFlat.setAttribute('aria-pressed', String(!kontur));
    bCont.setAttribute('aria-pressed', String(kontur));
  }
  if (bFlat && bCont) {
    bFlat.addEventListener('click', function () { cut(false); });
    bCont.addEventListener('click', function () { cut(true); });
    cut(false);
  }

  /* --------------------------------------------------------
     5 — Kaufleiste
     -------------------------------------------------------- */
  var leisteEl = $('#stickybar'), sName = $('#sticky-name'), sPreis = $('#sticky-price'),
      sSave = $('#sticky-save'), sImg = $('#sticky-img'), sCta = $('#sticky-cta');

  function leiste() {
    var a = D.angebote[angebot];
    if (!a) { return; }
    sName.textContent = a.name + ' · ' + farbText(angebot);
    sPreis.textContent = euro(a.preis);
    sSave.textContent = a.sparen > 0 ? '· du sparst ' + euro(a.sparen) : '';
    if (sImg) {
      if (angebot === 'single') {
        sImg.src = D.farbbilder[maske];
      } else {
        var id = variante(angebot);
        if (D.mini[id]) { sImg.src = D.mini[id]; }
      }
    }
  }
  $$('input[name="offer"]').forEach(function (input) {
    input.addEventListener('change', function () { angebot = input.value; leiste(); knoepfePflegen(); });
  });

  /* Die Leiste haengt am Kaufbutton, nicht am Hero.
     Auf dem Handy ist der Hero ueber 1100px hoch — haetten wir ihn
     beobachtet, waere der Besucher mehr als einen ganzen Bildschirm
     ohne einen einzigen Kaufbutton unterwegs. So erscheint die
     Leiste in dem Moment, in dem der echte Button oben aus dem Bild
     laeuft, und es ist nie ein Zustand erreichbar, in dem gar nichts
     zum Kaufen dasteht. */
  var heroCta = $('.buybox [data-kauf]') || $('#hero');
  if (heroCta && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) {
      leisteEl.classList.toggle('on', !e[0].isIntersecting);
    }, { threshold: 0 }).observe(heroCta);
  } else {
    window.addEventListener('scroll', function () {
      leisteEl.classList.toggle('on', window.scrollY > 400);
    }, { passive: true });
  }

  /* --------------------------------------------------------
     6 — Warenkorb
     -------------------------------------------------------- */
  var drawer = $('#drawer'), backdrop = $('#backdrop'), items = $('#drawer-items'),
      summe = $('#drawer-total'), toast = $('#toast'), upsellBox = $('#upsell');

  function melde(t) {
    toast.textContent = t;
    toast.classList.add('on');
    clearTimeout(melde.t);
    melde.t = setTimeout(function () { toast.classList.remove('on'); }, 2400);
  }
  function auf() {
    drawer.classList.add('on'); backdrop.classList.add('on');
    drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
  }
  function zu() {
    drawer.classList.remove('on'); backdrop.classList.remove('on');
    drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = '';
  }
  $('#drawer-close').addEventListener('click', zu);
  backdrop.addEventListener('click', zu);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { zu(); } });

  function hat(korb, id) {
    return korb.items.some(function (i) { return i.product_id === id; });
  }
  function zeile(bild, name, meta, txt, aktion, daten) {
    return '<div class="upsell__item">' +
      '<div class="upsell__img">' + (bild ? '<img src="' + bild + '" alt="" width="42" height="42" loading="lazy">' : '') + '</div>' +
      '<div class="upsell__main"><p class="upsell__name">' + name + '</p><p class="upsell__meta">' + meta + '</p></div>' +
      '<button class="upsell__btn" type="button" data-aktion="' + aktion + '" data-daten="' + daten + '">' + txt + '</button></div>';
  }
  function upsell(korb) {
    if (!korb.items || !korb.items.length || hat(korb, D.produkte.bundle)) { upsellBox.hidden = true; return; }
    var z = '', titel = '';
    if (hat(korb, D.produkte.duo)) {
      titel = 'Passt dazu';
      if (!hat(korb, D.produkte.tape) && D.zusatz.tape.id) {
        z += zeile(D.zusatz.tape.bild, D.zusatz.tape.name, 'Ruhige Atmung durch die Nacht · <b>' + euro(D.zusatz.tape.preis) + '</b>', 'Dazu', 'add', 'tape');
      }
      if (!hat(korb, D.produkte.plugs) && D.zusatz.plugs.id) {
        z += zeile(D.zusatz.plugs.bild, D.zusatz.plugs.name, 'Stille dazu · <b>' + euro(D.zusatz.plugs.preis) + '</b>', 'Dazu', 'add', 'plugs');
      }
    } else if (hat(korb, D.produkte.single)) {
      titel = 'Upgrade möglich';
      ['duo', 'bundle'].forEach(function (k) {
        var u = D.upgrade[k];
        if (!u || u.auf <= 0) { return; }
        /* Der Ersparnis-Zusatz nur, wenn Liquid eine gueltige
           Zahl geliefert hat. Faellt ein Produkt aus, steht dort
           0 — dann bleibt der Hinweis weg, statt "du sparst
           -19,00 €" anzubieten. */
        var sparText = u.sparen > 0
          ? ' · <span class="sv">du sparst ' + euro(u.sparen) + '</span>'
          : '';
        z += zeile(u.bild, u.name,
          u.dazu + ' · <b>+' + euro(u.auf) + '</b>' + sparText,
          'Upgraden', 'upgrade', k);
      });
    }
    if (!z) { upsellBox.hidden = true; return; }
    upsellBox.innerHTML = '<span class="upsell__title">' + titel + '</span>' + z;
    upsellBox.hidden = false;
    upsellBox.querySelectorAll('.upsell__btn').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.dataset.aktion === 'add') { zusatz(b.dataset.daten, b); }
        if (b.dataset.aktion === 'upgrade') { upgrade(b.dataset.daten, b, korb); }
      });
    });
  }
  function zeichnen(korb) {
    if (!korb.items || !korb.items.length) {
      items.innerHTML = '<p class="drawer__empty">Dein Warenkorb ist noch leer.</p>';
      summe.textContent = euro(0); upsellBox.hidden = true; return;
    }
    items.innerHTML = korb.items.map(function (it) {
      var bild = it.image ? '<img src="' + it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=128" alt="" width="58" height="58" loading="lazy">' : '';
      var v = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title + ' · ' : '';
      return '<div class="citem"><div class="citem__img">' + bild + '</div><div style="flex:1;min-width:0">' +
        '<p class="citem__name">' + it.product_title + '</p>' +
        '<p class="citem__var">' + v + it.quantity + '×</p>' +
        '<div class="citem__row"><span class="citem__price">' + euro(it.final_line_price) + '</span>' +
        '<button class="citem__rm" type="button" data-key="' + it.key + '">Entfernen</button></div></div></div>';
    }).join('');
    summe.textContent = euro(korb.total_price);
    items.querySelectorAll('.citem__rm').forEach(function (b) {
      b.addEventListener('click', function () {
        post(D.routen.change, { id: b.dataset.key, quantity: 0 })
          .then(zeichnen)
          .catch(function () { melde('Konnte nicht entfernt werden'); });
      });
    });
    upsell(korb);
  }
  function post(url, koerper) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(koerper)
    }).then(function (r) {
      if (!r.ok) { throw new Error('cart'); }
      return r.json();
    });
  }
  function korbLesen() { return fetch(D.routen.cart).then(function (r) { return r.json(); }); }

  function zusatz(k, btn) {
    var z = D.zusatz[k];
    if (!z || !z.id) { melde('Gerade nicht verfügbar'); return; }
    btn.setAttribute('aria-busy', 'true');
    post(D.routen.add, { items: [{ id: z.id, quantity: 1 }] })
      .then(korbLesen)
      .then(function (c) { zeichnen(c); melde(z.name + ' hinzugefügt'); })
      .catch(function () { melde('Hat nicht geklappt — bitte nochmal'); })
      .then(function () { btn.removeAttribute('aria-busy'); });
  }
  function upgrade(ziel, btn, korb) {
    var maske = korb.items.filter(function (i) { return i.product_id === D.produkte.single; })[0];
    var neu = variante(ziel);
    if (!maske || !neu) { melde('Upgrade gerade nicht möglich'); return; }
    var u = {}; u[maske.id] = 0; u[neu] = 1;
    btn.setAttribute('aria-busy', 'true');
    post(D.routen.update, { updates: u })
      .then(function (c) { zeichnen(c); melde('Upgrade auf ' + D.upgrade[ziel].name); })
      .catch(function () { melde('Upgrade hat nicht geklappt'); })
      .then(function () { btn.removeAttribute('aria-busy'); });
  }
  function inKorb(tier, button) {
    var id = variante(tier);
    if (!id) { melde('Diese Variante ist gerade nicht verfügbar'); return; }
    if (!angebotDa(tier)) { melde('Diese Kombination ist gerade ausverkauft'); return; }
    var alt = button.textContent;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Wird hinzugefügt …';
    post(D.routen.add, { items: [{ id: id, quantity: 1 }] })
      .then(korbLesen)
      .then(function (c) { zeichnen(c); auf(); })
      .catch(function () { melde('Hat leider nicht geklappt — bitte nochmal versuchen'); })
      .then(function () { button.removeAttribute('aria-busy'); button.textContent = alt; });
  }

  $$('[data-kauf]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      inKorb(b.dataset.kauf, b);
    });
  });
  if (sCta) { sCta.addEventListener('click', function () { inKorb(angebot, sCta); }); }

  /* --------------------------------------------------------
     7 — Kleinigkeiten
     -------------------------------------------------------- */
  var finale = $('#finale-cta');
  if (finale) {
    finale.addEventListener('click', function () {
      $('#angebote').scrollIntoView({ behavior: leise ? 'auto' : 'smooth', block: 'start' });
    });
  }
  var jahr = $('#jahr');
  if (jahr) { jahr.textContent = new Date().getFullYear(); }

  /* --------------------------------------------------------
     7c — Punkte unter dem Bewertungs-Karussell
     ------------------------------------------------------------
     Das Scrollen selbst macht der Browser (scroll-snap im
     Stylesheet). Hier entstehen nur die Punkte, und die werden
     erst eingeblendet, wenn dieses Skript laeuft — ohne Skript
     waeren sie tote Deko, die nichts anzeigt und nichts kann.

     Die Punkte sind echte Schaltflaechen: antippen springt zur
     Karte, mit Tastatur erreichbar. Der Streifen selbst ist per
     tabindex fokussierbar, damit man ihn auch ohne Maus mit den
     Pfeiltasten scrollen kann.
     -------------------------------------------------------- */
  var revs = $('.revs');
  var revdots = $('#revdots');
  if (revs && revdots) {
    var revKarten = Array.prototype.slice.call(revs.children);

    if (revKarten.length > 1) {
      revdots.hidden = false;
      revdots.removeAttribute('aria-hidden');
      revKarten.forEach(function (karte, i) {
        var p = document.createElement('button');
        p.type = 'button';
        p.setAttribute('aria-label', 'Zu Bewertung ' + (i + 1));
        if (i === 0) { p.className = 'an'; }
        p.addEventListener('click', function () {
          /* Mittig anfahren, nicht linksbuendig: Die Karten rasten
             per scroll-snap-align:center ein. Zielte man auf die
             linke Kante, korrigierte der Browser anschliessend um
             rund 45px nach — ein sichtbarer Nachruckler. */
          var ziel = (karte.offsetLeft - revs.offsetLeft)
                   - (revs.clientWidth - karte.offsetWidth) / 2;
          revs.scrollTo({ left: Math.max(0, ziel), behavior: leise ? 'auto' : 'smooth' });
        });
        revdots.appendChild(p);
      });

      var revPunkte = Array.prototype.slice.call(revdots.children);
      var revTickt = false;
      revs.addEventListener('scroll', function () {
        if (revTickt) { return; }
        revTickt = true;
        requestAnimationFrame(function () {
          revTickt = false;
          /* Welche Karte liegt der Mitte des Streifens am
             naechsten? Das ist zuverlaessiger als durch die
             Scroll-Position zu teilen, weil die Karten am Rand
             unterschiedlich viel Luft haben. */
          var mitte = revs.scrollLeft + revs.clientWidth / 2;
          var naechste = 0, kleinster = Infinity;
          revKarten.forEach(function (k, i) {
            var abstand = Math.abs((k.offsetLeft - revs.offsetLeft) + k.offsetWidth / 2 - mitte);
            if (abstand < kleinster) { kleinster = abstand; naechste = i; }
          });
          revPunkte.forEach(function (p, i) { p.classList.toggle('an', i === naechste); });
        });
      }, { passive: true });
    }
  }

  /* --------------------------------------------------------
     7b — Effekte ueber die ganze Seite
     ------------------------------------------------------------
     Alle drei haengen an "leise": Wer im System weniger Bewegung
     eingestellt hat, bekommt keinen davon. Und alle drei lesen im
     Scroll-Ereignis nur, geschrieben wird erst im naechsten
     Frame — sonst zwingt man den Browser bei jedem Pixel zu einem
     neuen Layout, und genau daran ruckelt es dann auf dem Handy.
     -------------------------------------------------------- */
  if (!leise) {

    /* Fortschrittslinie unter der Navigation. */
    var fortschritt = $('#nav-fortschritt');
    /* Bilder, die sich beim Scrollen leicht gegen die Seite
       bewegen. Sehr kleine Amplitude — es soll Tiefe andeuten,
       nicht auffallen. */
    /* Nur die grossen Split-Bilder. Die Bewertungsbilder haben
       schon ihren eigenen Aufzieh-Effekt beim Erscheinen; beides
       auf demselben Element hiesse zwei Regeln um dieselbe
       transform-Eigenschaft streiten zu lassen. */
    var parallax = $$('.split__media img');
    var tickt = false;

    function malen() {
      tickt = false;
      if (fortschritt) {
        var hoehe = document.documentElement.scrollHeight - window.innerHeight;
        var p = hoehe > 0 ? Math.min(1, window.scrollY / hoehe) : 0;
        fortschritt.style.transform = 'scaleX(' + p + ')';
      }
      var mitte = window.innerHeight / 2;
      parallax.forEach(function (bild) {
        var b = bild.getBoundingClientRect();
        if (b.bottom < -200 || b.top > window.innerHeight + 200) { return; }
        var weg = ((b.top + b.height / 2) - mitte) / window.innerHeight;
        bild.style.setProperty('--par', (weg * -14).toFixed(1) + 'px');
      });
    }
    function beiScroll() {
      if (tickt) { return; }
      tickt = true;
      requestAnimationFrame(malen);
    }
    window.addEventListener('scroll', beiScroll, { passive: true });
    window.addEventListener('resize', beiScroll, { passive: true });
    malen();

    /* Angebotskarten neigen sich leicht zum Zeiger. Nur mit
       echter Maus — auf Touchgeraeten wuerde das beim Tippen
       nur zappeln, und "hover" gibt es dort ohnehin nicht. */
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      $$('.offer__card').forEach(function (karte) {
        karte.addEventListener('mousemove', function (e) {
          var b = karte.getBoundingClientRect();
          var x = (e.clientX - b.left) / b.width - 0.5;
          var y = (e.clientY - b.top) / b.height - 0.5;
          karte.style.setProperty('--kx', (y * -4).toFixed(2) + 'deg');
          karte.style.setProperty('--ky', (x * 5).toFixed(2) + 'deg');
        });
        karte.addEventListener('mouseleave', function () {
          karte.style.setProperty('--kx', '0deg');
          karte.style.setProperty('--ky', '0deg');
        });
      });
    }
  }

  /* --------------------------------------------------------
     8 — Vorher/Nachher-Regler (Blaulicht)
     ------------------------------------------------------------
     Die ganze Mechanik steckt im Stylesheet: Das obere Bild ist
     per clip-path links beschnitten, der Beschnitt haengt an der
     Variablen --pos. Hier wird nichts weiter getan, als den
     Reglerwert dorthin zu schreiben.

     Bedient wird ein echtes <input type="range">. Ziehen, Tippen,
     Pfeiltasten, Pos1/Ende und Vorlesesoftware funktionieren
     dadurch von selbst — nichts davon muesste man nachbauen.

     Der Abschnitt kann fehlen: Ohne die beiden Bilder rendert
     Liquid ihn gar nicht erst. Deshalb die Pruefung.
     -------------------------------------------------------- */
  /* --------------------------------------------------------
  /* --------------------------------------------------------
     9 — Quiz
     ------------------------------------------------------------
     Drei Fragen, jede Antwort ein Punkt auf maske, duo oder
     bundle. Am Ende gewinnt der hoechste Stand; bei Gleichstand
     das Duo, weil es das beworbene Angebot ist.

     Die Fragen liegen im Stylesheet uebereinander und schieben
     sich seitlich durch. Hier wird nur umgeschaltet: die alte
     Frage bekommt "raus", die neue "an". Die feste Hoehe der
     Buehne wird vorher gemessen und gesetzt, sonst springt die
     Seite unter dem Finger, wenn die naechste Frage kuerzer ist.

     Preise kommen aus window.NOC — dieselben Zahlen wie ueberall
     sonst. Ist eine Ersparnis ungueltig (Liquid liefert dann 0),
     bleibt das Schild weg statt eine falsche Zahl zu zeigen.
     -------------------------------------------------------- */
  var quiz = $('#quiz');
  if (quiz) {
    var qFragen   = $$('#quiz .quiz__frage');
    var qBuehne   = $('.quiz__buehne');
    var qPunkte   = $$('#quiz .quiz__punkte i');
    var qErgebnis = $('#quiz-ergebnis');
    var qStand    = { maske: 0, duo: 0, bundle: 0 };
    var qSchritt  = 0;
    var qBlockiert = false;

    var QTEXT = {
      maske:  { tier:'single', titel:'Nur die Maske',     warum:'Licht ist dein Problem, nicht der Abend davor. Die Kontur hält den Stoff von den Lidern — auch in Seitenlage.' },
      duo:    { tier:'duo',    titel:'The Midnight Duo',  warum:'Bei dir faengt es vor dem Bett an. Die Brille nimmt das Blaulicht, die Maske danach das Licht.' },
      bundle: { tier:'bundle', titel:'Deep Sleep Bundle', warum:'Bei dir kommt Lärm dazu. Maske gegen Licht, Plugs gegen Geräusche, Tape für ruhige Atmung.' }
    };

    /* Die gewaehlten Antworten, als Satzteile. Jede Antwort traegt
       ihre Formulierung in data-echo; daraus wird am Ende ein Satz
       in den Worten des Besuchers.

       Warum der Aufwand: Vorher stand im Ergebnis nur ein fester
       Satz pro Produkt — bei jedem derselbe, egal was geklickt
       wurde. Genau daran merkt man, dass die Antworten keine
       Rolle spielten, und dann wirkt der ganze Finder wie Deko.
       Jetzt bekommt der Besucher zuerst seine eigene Nacht
       vorgelesen und danach die Empfehlung. */
    var qEchos = [];

    function qSatzBauen() {
      if (!qEchos.length) { return ''; }
      var s = qEchos.join(', ')
        /* "…, und die letzte Stunde…" liest sich als Aufzaehlung
           besser ohne das doppelte Komma vor dem "und". */
        .replace(/, und /g, ' und ');
      return s.charAt(0).toUpperCase() + s.slice(1) + '.';
    }

    /* Hoehe der hoechsten Frage festhalten, damit beim Wechsel
       nichts springt. Nach dem Laden der Schrift neu messen. */
    function qHoeheSetzen() {
      var max = 0;
      qFragen.forEach(function (f) {
        var wieder = f.classList.contains('an');
        f.style.position = 'relative';
        f.style.opacity = '0';
        max = Math.max(max, f.offsetHeight);
        f.style.position = '';
        f.style.opacity = '';
        if (!wieder) { f.classList.remove('an'); }
      });
      if (max > 0) { qBuehne.style.minHeight = max + 'px'; }
    }

    function qZeige(i) {
      qFragen.forEach(function (f, n) {
        f.classList.toggle('an', n === i);
        f.classList.toggle('raus', n < i);
      });
      qPunkte.forEach(function (p, n) { p.classList.toggle('an', n <= i); });
    }

    function qAuswerten() {
      var sieger = 'duo', best = -1;
      ['duo', 'maske', 'bundle'].forEach(function (k) {
        /* Bundle nicht im Shop (Entwurf -> Preis null): nicht empfehlen,
           die Karte dazu gibt es dann auch nicht. */
        if (k === 'bundle' && !(D.angebote.bundle && D.angebote.bundle.preis > 0)) { return; }
        if (qStand[k] > best) { best = qStand[k]; sieger = k; }
      });
      var e = QTEXT[sieger];
      var a = D.angebote[e.tier] || {};
      var spar = a.sparen > 0
        ? '<s>' + euro(a.preis + a.sparen) + '</s><span class="save">du sparst ' + euro(a.sparen) + '</span>'
        : '';

      qFragen.forEach(function (f) { f.classList.remove('an'); f.classList.add('raus'); });
      qPunkte.forEach(function (p) { p.classList.add('an'); });
      qBuehne.style.minHeight = '';
      qBuehne.hidden = true;

      /* Erst die eigene Nacht, dann die Empfehlung. Der Pfeil
         dazwischen macht die Schlussfolgerung sichtbar. */
      var satz = qSatzBauen();
      qErgebnis.innerHTML =
        (satz
          ? '<p class="quiz__eyebrow">Deine Nacht</p>' +
            '<p class="quiz__echo">' + satz + '</p>' +
            '<span class="quiz__pfeil" aria-hidden="true"></span>'
          : '') +
        '<p class="quiz__eyebrow">Unsere Empfehlung</p>' +
        '<p class="quiz__name">' + e.titel + '</p>' +
        '<p class="quiz__warum">' + e.warum + '</p>' +
        '<p class="quiz__preis"><b data-ziel="' + (a.preis || 0) + '">' + euro(a.preis || 0) + '</b>' + spar + '</p>' +
        '<button class="btn btn--primary btn--full" type="button">In den Warenkorb</button>' +
        '<br><button class="quiz__neu" type="button">Noch mal von vorn</button>';
      qErgebnis.hidden = false;
      qErgebnis.classList.remove('rein');
      void qErgebnis.offsetWidth;
      qErgebnis.classList.add('rein');

      if (!leise) { hochzaehlen(qErgebnis.querySelector('[data-ziel]')); }

      var kaufKnopf = qErgebnis.querySelector('.btn--primary');
      kaufKnopf.addEventListener('click', function () { inKorb(e.tier, kaufKnopf); });
      qErgebnis.querySelector('.quiz__neu').addEventListener('click', function () {
        qStand = { maske: 0, duo: 0, bundle: 0 };
        qEchos = [];
        qSchritt = 0;
        qBlockiert = false;
        qErgebnis.hidden = true;
        qErgebnis.innerHTML = '';
        qBuehne.hidden = false;
        qFragen.forEach(function (f) { f.classList.remove('raus'); });
        qHoeheSetzen();
        qZeige(0);
      });
    }

    quiz.addEventListener('click', function (ev) {
      var b = ev.target.closest('.quiz__opt button');
      if (!b || qBlockiert) { return; }
      qBlockiert = true;
      b.classList.add('gewaehlt');
      qStand[b.dataset.punkt] += 1;
      if (b.dataset.echo) { qEchos.push(b.dataset.echo); }

      /* Kurz stehen lassen, damit die Auswahl sichtbar quittiert
         wird — ohne die Pause wirkt der Wechsel wie ein Ruckeln. */
      setTimeout(function () {
        b.classList.remove('gewaehlt');
        qSchritt += 1;
        qBlockiert = false;
        if (qSchritt >= qFragen.length) { qAuswerten(); } else { qZeige(qSchritt); }
      }, leise ? 0 : 220);
    });

    qHoeheSetzen();
    qZeige(0);
    window.addEventListener('load', qHoeheSetzen);
    window.addEventListener('resize', qHoeheSetzen);
  }


  var baBuehne = $('.ba__stage');
  if (baBuehne) {
    var baRegler = baBuehne.querySelector('.ba__range');
    if (baRegler) {
      var baSetzen = function () {
        baBuehne.style.setProperty('--pos', baRegler.value + '%');
      };
      baRegler.addEventListener('input', baSetzen);
      baSetzen();
    }

    /* Netz fuer den Fall, dass eines der beiden Bilder spaeter aus
       den Dateien verschwindet. Shopify liefert dann trotzdem eine
       Adresse, die erst beim Laden mit 404 antwortet — der Besucher
       saehe einen kaputten Rahmen mit einem Regler daran. Lieber
       den ganzen Abschnitt still entfernen. */
    var baAbschnitt = baBuehne.closest('#blaulicht');
    baBuehne.querySelectorAll('.ba__img').forEach(function (bild) {
      bild.addEventListener('error', function () {
        if (baAbschnitt) { baAbschnitt.remove(); }
      });
    });
  }

  swatchesPflegen();
  knoepfePflegen();
  leiste();
  bilderAktualisieren();

  /* ViewContent — mit dem echten Preis, nicht mit 0, und mit dem
     Duo statt der Einzelmaske: beworben wird das Duo, also muss
     Meta auch dessen Wert lernen. Sonst optimiert der Algorithmus
     auf einen Warenkorb, den die Anzeige gar nicht anbietet. */
  if (typeof fbq !== 'undefined' && D.angebote.duo.preis > 0) {
    fbq('track', 'ViewContent', {
      content_ids: [String(variante('duo'))],
      content_type: 'product',
      content_name: D.angebote.duo.name,
      value: D.angebote.duo.preis / 100,
      currency: D.waehrung
    });
  }
})();